module.exports = __webpack_public_path__ + "img/stickynote.cc92e841.svg";